import { IconButton, Stack, Typography } from '@mui/material';
import { FAIcon } from '@packages/ui-components';
import dayjs from 'dayjs';
import { useDatePickerStore } from '../../hooks/use-store';

export function MonthSwitch() {
  const currentMonth = useDatePickerStore((state) => state.currentMonth);
  const { moveCurrentMonth } = useDatePickerStore((state) => state.actions);

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <IconButton onClick={() => moveCurrentMonth(-1)}>
        <FAIcon
          icon="faChevronLeft"
          size={18}
          color="#667085"
        />
      </IconButton>
      <Typography
        sx={{
          color: 'var(--Gray-700, #344054)',
          textAlign: 'center',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '24px',
        }}
      >
        {dayjs(currentMonth).format('MMMM YYYY')}
      </Typography>
      <IconButton onClick={() => moveCurrentMonth(1)}>
        <FAIcon
          icon="faChevronRight"
          size={18}
          color="#667085"
        />
      </IconButton>
    </Stack>
  );
}
